import React from 'react';
import { Listbox, ListboxItem } from "@heroui/react";
import {
  ListBoxProps,
  ListboxWrapper,
  getEndContent,
  listBoxSlotStyles,
} from '../DropdownListBox';
import { TooltipContent } from '../../tooltips/CustomTooltips';

export const UnSectionedListBox: React.FC<ListBoxProps> = ({
  itemsList,
  itemStyleClasses,
  closeDropdown,
  border,
  setShowPopover,
  showPopover,
  showTooltip,
}) => {
  const isLoading = itemsList.some((item) => item?.loading === true);
  const defaultItemStyleClasses = 'gap-[12px]';
  const customItemStyleClasses = itemStyleClasses || defaultItemStyleClasses;
  return (
    <ListboxWrapper border={border}>
      <Listbox
        role="listbox"
        variant="flat"
        aria-label="List Dropdown"
        classNames={listBoxSlotStyles.listbox}
      >
        {itemsList?.map((item, index) => {
          return (
            <ListboxItem
              className={item.item}
              data-testid={item?.item}
              aria-label={item?.item}
              classNames={{
                base: `${customItemStyleClasses} ${
                  isLoading ? 'cursor-not-allowed' : ''
                } ${item?.loading ? 'bg-translucentGray' : ''}`,
              }}
              key={`${index * 1}-item`}
              onClick={() => {
                if (!item?.hasPopover && !item?.noCloseonSelect) {
                  closeDropdown();
                }
                return !isLoading && item?.triggerFunction?.();
              }}
              onMouseEnter={() => item?.hasPopover && setShowPopover?.(true)}
              onMouseLeave={() => item?.hasPopover && setShowPopover?.(false)}
              startContent={item?.loading ? item?.loader : item?.startIcon}
              endContent={getEndContent(
                item?.endIcon,
                item?.shortcut,
                item,
                closeDropdown,
                showPopover,
              )}
              isDisabled={item?.isDisabled}
            >
              {showTooltip ? (
                <TooltipContent
                  content={item?.item}
                  showTooltip={showTooltip}
                  tooltipContent={item?.item}
                />
              ) : (
                item.item
              )}
            </ListboxItem>
          );
        })}
      </Listbox>
    </ListboxWrapper>
  );
};
